/**
 * @generated SignedSource<<4d4d8143f064eb027fcd41a2be79539a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueFormElements_templateElements$data = {
  readonly elements: ReadonlyArray<{
    readonly __typename: "IssueFormElementCheckboxes";
    readonly " $fragmentSpreads": FragmentRefs<"CheckboxesElement_input">;
  } | {
    readonly __typename: "IssueFormElementDropdown";
    readonly " $fragmentSpreads": FragmentRefs<"DropdownElement_input">;
  } | {
    readonly __typename: "IssueFormElementInput";
    readonly " $fragmentSpreads": FragmentRefs<"TextInputElement_input">;
  } | {
    readonly __typename: "IssueFormElementMarkdown";
    readonly " $fragmentSpreads": FragmentRefs<"MarkdownElement_input">;
  } | {
    readonly __typename: "IssueFormElementTextarea";
    readonly " $fragmentSpreads": FragmentRefs<"TextAreaElement_input">;
  } | {
    readonly __typename: "IssueFormElementUpload";
    readonly " $fragmentSpreads": FragmentRefs<"UploadElement_input">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly " $fragmentType": "IssueFormElements_templateElements";
};
export type IssueFormElements_templateElements$key = {
  readonly " $data"?: IssueFormElements_templateElements$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFormElements_templateElements">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueFormElements_templateElements"
};

(node as any).hash = "60d8de5d7abb34b5d1a8ee16008c8224";

export default node;
